import HighlightCellHelper from 'main/components/show/cuesheet/highlightCellHelper';

//TODO: remove this in favor of using the HighlightCellHelper directory...this doesn't really have any business being a mixin
export default {
  getGlobalHighlightStyle(item) {
    item = item ? item : this.props.item;
    return HighlightCellHelper.getGlobalHighlightStyle(item);
  },

  getPersonalHighlightStyle(itemParam, userIdParam) {
    let { item, userId } = this.props;

    item = itemParam ? itemParam : item;
    userId = userIdParam ? userIdParam : userId;

    return HighlightCellHelper.getPersonalHighlightStyle(item, userId);
  },

  getPersonalHighlightClass(itemParam, userIdParam) {
    let { item, userId } = this.props;

    item = itemParam ? itemParam : item;
    userId = userIdParam ? userIdParam : userId;

    return HighlightCellHelper.getPersonalHighlightClass(item, userId);
  },
};
